"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.whiteListLogHeaders = exports.AdditionalHeaders = void 0;
var AdditionalHeaders;
(function (AdditionalHeaders) {
    /**
     * Эти заголовки используется для сквозного логирования
     *
     * Формат мобайла:
     *  X-B3-TraceId
     *  X-B3-SpanId
     */
    AdditionalHeaders["traceId"] = "x-b3-traceid";
    AdditionalHeaders["spanId"] = "x-b3-spanid";
    /**
     * ⚠
     * Заголовок для подмены канала
     */
    AdditionalHeaders["hackChannelId"] = "hack-channel-id";
    AdditionalHeaders["channelId"] = "channel-id";
    AdditionalHeaders["xsrf"] = "x-csrf-token";
    AdditionalHeaders["cus"] = "customerid";
    AdditionalHeaders["proxyRequestsFrom"] = "proxy-requests-from";
})(AdditionalHeaders = exports.AdditionalHeaders || (exports.AdditionalHeaders = {}));
/**
 * Список допустимых для логирования заголовков
 */
exports.whiteListLogHeaders = [
    'accept',
    'accept-encoding',
    'accept-language',
    'applicationId',
    'connection',
    'content-length',
    'content-type',
    'forwarded',
    'host',
    'referer',
    'sec-fetch-dest',
    'sec-fetch-mode',
    'sec-fetch-site',
    'user-agent',
    'x-b3-parentspanid',
    'x-b3-sampled',
    'x-forwarded-for',
    'x-forwarded-host',
    'x-forwarded-port',
    'x-forwarded-prefix',
    'x-forwarded-proto',
    'x-real-ip',
    AdditionalHeaders.channelId,
    AdditionalHeaders.cus,
    AdditionalHeaders.spanId,
    AdditionalHeaders.traceId,
];

//# sourceMappingURL=headers.js.map
